//components
import React, { useState, useEffect } from "react";
import AboutInfo from "../components/AboutInfo";
import AboutParts from "../components/AboutParts";
import Footer from "../components/Footer";
import GalleryCarousel from "../components/GalleryCC";
import VideoCarousel from "../components/VideoGalleryCC";
import FooterCopyright from "../components/FooterCopyright";
import img6 from "../assets/aboutus.jpg";
import img17 from "../assets/image17.webp";
import img8 from "../assets/image8.webp";
import "../styles/about.css";
const imageUrls = [
  "https://www.littlesanctumpreschools.in/googleads3.jpg",
  "https://www.littlesanctumpreschools.in/googleads2.jpg",
  "https://www.littlesanctumpreschools.in/googleads1.jpg",
  "https://www.littlesanctumpreschools.in/googleads4.jpg",
  "https://www.littlesanctumpreschools.in/1.jpg",
  "https://www.littlesanctumpreschools.in/2.jpg",
  "https://www.littlesanctumpreschools.in/3.jpg",
  "https://www.littlesanctumpreschools.in/4.jpg",
  "https://www.littlesanctumpreschools.in/5.jpg",
  "https://www.littlesanctumpreschools.in/6.jpg",
  "https://www.littlesanctumpreschools.in/7.jpg",
  "https://www.littlesanctumpreschools.in/8.jpg",
  "https://www.littlesanctumpreschools.in/9.jpg",
  "https://www.littlesanctumpreschools.in/10.jpg",
  "https://www.littlesanctumpreschools.in/11.jpg",
  "https://www.littlesanctumpreschools.in/12.jpg"
];
const videoIds = ["Rnpw-X9j1Fw", "iG7njbhMiJ8", "bbFAzKQSmn0"];
const About = () => {
  const images = [img6, img17, img8];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setCurrent((c) => (c + 1) % images.length), 4200);
    return () => clearInterval(id);
  }, [images.length]);

  return (
    <>
      <div className="about-hero page-hero">
        {images.map((img, i) => (
          <div
            key={i}
            className={`bg-layer ${i === current ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <button className="hero-nav prev" onClick={() => setCurrent((current - 1 + images.length) % images.length)} aria-label="Previous image">‹</button>
        <button className="hero-nav next" onClick={() => setCurrent((current + 1) % images.length)} aria-label="Next image">›</button>
        <div className="about-hero-inner page-hero-inner">
          <h2 className="title">About us</h2>
        </div>
        <div className="hero-dots">
          {images.map((_, i) => (
            <button
              key={i}
              className={`hero-dot ${i === current ? 'active' : ''}`}
              onClick={() => setCurrent(i)}
              aria-label={`Go to image ${i + 1}`}
            />
          ))}
        </div>
      </div>

      <AboutInfo />
      <GalleryCarousel images={imageUrls} />
      <VideoCarousel videoIds={videoIds} />
      <AboutParts />
      <Footer />
      <FooterCopyright />
    </>
  );
};

export default About;